import React from 'react';
import { ListItem } from './list-item';
import { ListResultsProps } from 'app/area/import-sets-administration/list/types-store';
import styles from './list-results.scss';

export const ListResults: React.FC<ListResultsProps> = ({
  listItems, deletingImportSets, deleteImportSet, translation
}) => listItems?.length > 0
    ? <div className={styles.listItems}>
      {listItems.map(listItem => {
        return <ListItem
          key={listItem.value}
          item={listItem}
          deleting={deletingImportSets?.includes(listItem.value)}
          deleteImportSet={deleteImportSet}
          translation={translation}
        />;
      })}
    </div>
    : null;
